import React from 'react';
import AnswerForms from "./AnswerForms";
function GradingSchemesLoader(_ref) {
  var formValidated = _ref.formValidated,
    onChange = _ref.onChange,
    value = _ref.value,
    gradingSchemes = _ref.gradingSchemes;
  return /*#__PURE__*/React.createElement(AnswerForms, {
    formValidated: formValidated,
    gradingSchemes: gradingSchemes,
    onChange: onChange,
    value: value
  });
}
export default GradingSchemesLoader;